import React,{useState,useEffect} from 'react';
import DataTable from 'react-data-table-component';
import * as RestService from '../../services/eisRest';
import { Button} from 'react-bootstrap';
import FileSaver from 'file-saver';
import LoadingOverlay from 'react-loading-overlay';
import {useTranslation} from 'react-i18next';

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const DataTableX = (props) => {

    const [t] = useTranslation();      
    const [url, setUrl] = useState();
    const [urlExcel, setUrlExcel] = useState();
    const [data, setData] = useState();   
    const [columnsData, setColumnsData] = useState();
    const [loading, setLoading] = useState(false);
    const [exportRunning, setExportRunning] = useState(false);    
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);    
    const [selectedColumn, setSelectedColumn] = useState(1);    
    const [sortDirection, setSortDirection] = useState('asc');        
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);        

 
   

    const customStyles = {
      rows: {
        style: {
        //  fontFamily: "Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
          fontSize: '15px'
        }        
      },
      header: {
        style: {
          fontSize: '22px',
          fontWeight: 800
        },
      },     
      headCells: {
        style: {
          fontSize: '17px',
          fontWeight: 800
          
        },
      }
    };


   const handleOnSort = (selectedColumn, sortDirection ) => {
      setSelectedColumn(selectedColumn);
      setSortDirection(sortDirection);
      
      props.columnsData.find(function(item, i){
        
        if(item.data === selectedColumn.data){
          setSelectedColumn(i);
          fetchData(url,currentPage,perPage,i,sortDirection);
        }
      });
      return;
      
   }

    
    const fetchData = (url,page, size = perPage, selectedColumn = 1, sortDirection = 'asc', search = '') => {
        if(typeof url=== 'undefined'){return;}
        setLoading(true);          
             
        RestService.callAnyApi(url,{
            columns: props.columnsData,
            order: [{column: selectedColumn,dir: sortDirection}],
            search: {value: search,regex: false},
            draw: page-1,
            length: size,
            start: ((page-1)*size)          
        })
          .then((response) => {          
                  

            setData(response.data);
            setTotalRows(response.recordsFiltered);
            setLoading(false);
          })
          .catch((error) => {               
            setLoading(false);
          });
    
       
      };

      
     
        
    
      useEffect(() => {
        fetchData(url,currentPage,perPage,selectedColumn,sortDirection,filterText);
      }, []);
    
      useEffect(() => {
        fetchData(url,currentPage,perPage,selectedColumn,sortDirection,filterText);
      }, [props.modalShow]);
    
      useEffect(() => {
        fetchData(url,currentPage,perPage,selectedColumn,sortDirection,filterText);
      }, [props.checkTime]);
      

      useEffect(() => {
          setUrl(props.url);
          fetchData(props.url,currentPage,perPage,selectedColumn,sortDirection,filterText);
      }, [props.url]);
    
      useEffect(() => {
        setUrl(props.url);
        fetchData(props.url,currentPage,perPage,selectedColumn,sortDirection,filterText);
    }, [props.url]);
  

    useEffect(() => {
      setUrlExcel(props.urlExcel);      
    }, [props.urlExcel]);

    useEffect(() => {
      setColumnsData(props.columnsData);  
    }, [props.columnsData]);

      

      const handlePageChange = page => {
        fetchData(page);
        setCurrentPage(page);
        fetchData(url,page, perPage);
      };
    
      const handlePerRowsChange = async (newPerPage, page) => {
        fetchData(url,page, newPerPage);
        setPerPage(newPerPage);
      };

  
      const handleRowClicked = (row) =>{
        //console.log(row);
        props.parentCallback(row.id); 
      }


      const exportExcel = () =>{
          setExportRunning(true);       
          RestService.downloadExceFile(urlExcel,{
                columns: columnsData,
                order: [{column: selectedColumn,dir: sortDirection}],
                search: {value: filterText,regex: false},
                draw: currentPage-1,
                length: perPage,
                start: ((currentPage-1)*perPage)          
          })          
          .then((response) => {       
             //FileDownload(response.data, 'report.xls');   

             //console.log(response.headers);
             const filename = response.headers['content-disposition']
             
             //const filename = obj.Get('content-disposition');
             //const filename = ""; //response.headers.json(); // .headers .get('content-disposition')           
           //  const z = filename.content-disposition;
             .split(';')
             .find(n => n.includes('filename='))
             .replace('filename=', '')
             .trim()
           ;
       
           //const blob = await response.blob();

             FileSaver.saveAs(response.data,filename);//, 'report.xlsx'
             setExportRunning(false);       
             // console.log(response);
          })
          .catch((error) => {               
            console.log(error);
            setExportRunning(false);       
          });               

      };

      const FilterComponent = ( { filterText, onClear, onFilter }) => {
       
                return(
                <>       
                  <div className="row">    
                    

                            {/*<Button className="btn-default" onClick={exportExcel}>Export to Pdf
                                <i className="fas fa-file-pdf" style={{marginLeft: '10px'}}></i>
                            </Button>
                */}
                      {props.exportShow ?
                       
                            <Button className="btn-default" style={{marginLeft: '10px'}} onClick={exportExcel}>Export to Excel 
                                <i className="fas fa-file-excel" style={{marginLeft: '10px'}}></i>
                            </Button>
                        
                            : <></>
                      }                           
                        
                    
                    <div style={{width: '300px', marginLeft:'20px'}}>
                        <div className="input-group">
                            <div className="form-outline">
                                <input  type="text" autoFocus className="form-control" value={filterText} onChange={onFilter}  placeholder={t('general.label.search')}/>   
                            </div>
                            <Button  onClick={onClear}>
                                <i className="fas fa-times"></i>
                            </Button>
                        </div>          
                    </div>
                  </div>
                </>
              );
        };

    

      const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
          if (filterText) {
            setResetPaginationToggle(!resetPaginationToggle);
            setFilterText('');
          }
        };

        fetchData(url,currentPage,perPage,selectedColumn,sortDirection,filterText);
       

       
    
        return (
                  <>                   
                  <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
                  </>
               );
      }, [filterText, resetPaginationToggle,urlExcel,columnsData]);

        return (
          <>
         <LoadingOverlay
  active={exportRunning}
  spinner
  text='Export running...'
  >
  <DataTable
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              //  subHeader={false}
                fixedHeader
                fixedHeaderScrollHeight="500px"
                title={props.tableName}
                columns={props.columns}
                data={data}                
                progressPending={loading}
                pagination
                paginationServer
                //sortServer         
                paginationTotalRows={totalRows}
                paginationDefaultPage={currentPage}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                onSort={handleOnSort}              
               // selectableRows
                highlightOnHover
                onRowClicked={handleRowClicked}                
                onSelectedRowsChange={({ selectedRows }) => console.log(selectedRows)}
                paginationResetDefaultPage={resetPaginationToggle} 
                customStyles={customStyles}
                striped={false}
                responsive={true}
                wrap={true}
               // dense={true}
                />
</LoadingOverlay>
           
              
          </>
          
        );
}

export default DataTableX;